/* particlesJS.load(@dom-id, @path-json, @callback (optional)); */



jQuery(document).ready(function(){
	
	//fix loadig js lag
	jQuery('.no-js').removeClass("no-js");
	
	//big carousel
	jQuery('.main-carousel').slick({
		autoplay:true,
		dots:false,
        adaptiveHeight:true,
        arrows:false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplaySpeed: 3000,
        speed: 1000
  });
    
    
    
    jQuery('.product-slider-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.product-slider-nav'
    });
    
    jQuery('.product-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.product-slider-main',
      //dots: false,
      centerMode: false,
      focusOnSelect: true,
        arrows:true
    });
				
    
   checkTable();
     
});

// requires jquery library
jQuery(document).ready(function() {
   jQuery(".table-scroll").clone(true).appendTo('.scheda-tecnica-tab').addClass('clone');   
 });


$(window).resize(function(){
    checkTable();
})


function checkTable(){
    var wrapper =  $('.wrapper').width();
    var table = $('.table-scroll').width();
    
    
    if(wrapper < table){
        $('.small-screen').css({display: "block"});
    }else{
        $('.small-screen').css({display: "none"});
    }
    
}


new WOW().init();